(function ($) {
	// On Dom Ready
	$(function () {
		toggle_header_style();

		// sticky header
		window.onscroll = function () {
			toggle_header_style();
		};

		function toggle_header_style() {
			if ($("body").hasClass("is-front-page")) {
				if (
					document.body.scrollTop > 100 ||
					document.documentElement.scrollTop > 100
				) {
					$(".site-header").removeClass("large");
				} else {
					$(".site-header").addClass("large");
				}
			} else {
				$(".site-header").removeClass("large");
			}
		}
	});
})(jQuery);
